import { SLICE_NAME } from './index';
import reducer from './store';

export default {
  [SLICE_NAME]: reducer,
};
